import React, { useState, useEffect, useContext } from 'react';
import UserContext from '../../context/UserContext.js';
import BotonInsertar from '../UI/botones/BotonInsertar.js';
import DetalleGolesEquipo from './DetalleGolesEquipo.js';
import FormacionSeparador from './FormacionSeparador.js';
import ParticipanteFormacion from './ParticipanteFormacion.js';
import SelectFormacion from '../selectores/SelectFormacion.js';
import MensajeCargando from '../UI/MensajeCargando.js';
import MensajeError from '../UI/MensajeError.js';
import MensajeGrabando from '../UI/MensajeGrabando.js';
import PopupsFormacion, { TipoPopup } from './PopupsFormacion.js';
import TecnicoFormacion from './TecnicoFormacion.js';
import { PersonaFormacion as Campos } from '../constantes/Campos.js';
import * as Localia from '../constantes/Localia.js';
import * as TipoSustitucion from '../constantes/TipoSustitucion.js';
import * as Titularidad from '../constantes/Titularidad.js';
import * as Data from '../data/DataPartidos.js';
import * as DTOs from '../DTOs/PartidoDTOs.js';
import { MapFormacionDesdeBackend, ItemFormacionVacio } from '../DTOs/FormacionDTOs.js';
import { encontrarIdNumber } from '../funciones/FuncionesArray.js';
import { CamposToFechaBase } from '../funciones/FuncionesFecha.js';
import * as Funciones from '../funciones/FuncionesFormacion.js';
import { Boton } from '../funciones/FuncionesFormacion.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './FormacionPartido.module.css';

const FormacionPartido = (props) => {
  const partido = props.partido;
  const localia = props.localia;
  const equipo = props.equipo;
  const cantSuplentes = props.cantSuplentes;
  const formacion = props.formacion;
  const tipoFormacion = props.tipoFormacion;
  const grabar = props.grabar;
  const goles = props.goles;
  const sustituciones = props.sustituciones;
  const { usuario } = useContext(UserContext);
  const puedeEditar = usuario && usuario.puedeEditar;
  const [plantel, setPlantel] = useState([]);
  const [popup, setPopup] = useState(PopupsFormacion.PopupOculto);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const [erroresPost, setErrorPost] = useState('');
  const [grabando, setGrabando] = useState(false);
  const [grabandoFormacion, setGrabandoFormacion] = useState(false);
  const [grabandoTipoFormacion, setGrabandoTipoFormacion] = useState(false);

  const idTorneo = partido && partido.torneo ? partido.torneo.id : null;
  const idEquipo = equipo && equipo.id;

  const separadoresVisibles = Funciones.SeparadoresVisibles(tipoFormacion);

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  let fechaPartido = null;
  if (partido) {
    fechaPartido = CamposToFechaBase(partido.anioPartido, partido.mesPartido, partido.diaPartido);
  }

  // Efecto para cargar el plantel del equipo en el torneo
  useEffect(() => {
    if (idEquipo) {
      if (idTorneo) {
        fetchData('torneos/' + idTorneo + '/participantes/' + idEquipo + '/plantel', setPlantel);
      } else {
        fetchData('equipos/' + idEquipo + '/plantel_fecha/' + fechaPartido, setPlantel);
      }
    } else {
      setPlantel([]);
    }
  }, [idTorneo, idEquipo, fechaPartido, fetchData]);

  const actualizarAmonestacion = async (participante) => {
    setErrorPost('');
    if (puedeEditar) {
      setGrabando(true);
      try {
        await Data.PatchParticipanteAmonestado(partido.id, idEquipo, participante);
        props.onFormacionActualizada(
          localia,
          Funciones.ActualizarCampoJugador(
            formacion,
            participante,
            Campos.AMONESTADO,
            participante.amonestado
          ),
          false
        );
      } catch (error) {
        setErrorPost(error.message);
      }
      setGrabando(false);
    }
  };

  const actualizarCampo = (participante, campo, numero) => {
    if (puedeEditar) {
      const formacionActualizada = Funciones.ActualizarCampoJugador(
        formacion,
        participante,
        campo,
        numero
      );
      props.onFormacionActualizada(localia, formacionActualizada, true);
    }
  };

  const grabarHandler = async () => {
    setErrorPost('');
    if (puedeEditar) {
      setGrabandoFormacion(true);
      try {
        const actualizar = await Funciones.GrabarFormacion(partido.id, idEquipo, formacion);
        let formacionActualizada = formacion;
        if (actualizar) {
          // Si hay registros nuevos, recargar desde el backend para obtener los IDs
          const formacionBackend = await Data.FetchFormacion(partido.id, idEquipo);
          const formacionBase = MapFormacionDesdeBackend(formacionBackend);
          formacionActualizada = Funciones.ArmarPuestosFormacion(
            partido.id,
            equipo,
            formacionBase,
            cantSuplentes
          );
        } else {
          // Si solo se actualizaron registros existentes, resetear el flag modificado
          formacionActualizada = Funciones.ResetearModificados(formacion);
        }
        props.onFormacionActualizada(localia, formacionActualizada, false);
      } catch (error) {
        setErrorPost(error.message);
      }
      setGrabandoFormacion(false);
    }
  };

  const insertarTecnicoHandler = () => {
    if (puedeEditar && formacion) {
      // Encontrar el orden más alto entre los técnicos actuales
      const tecnicos = formacion.filter(
        (item) => item.titularidad === Titularidad.DIRECTOR_TECNICO
      );
      let ordenNuevo = 12 + cantSuplentes; // orden base para el primer técnico

      if (tecnicos.length > 0) {
        // Encontrar el orden máximo y agregar 1
        const ordenMaximo = Math.max(...tecnicos.map((t) => t.orden));
        ordenNuevo = ordenMaximo + 1;
      }

      // Crear nuevo técnico vacío
      const nuevoTecnico = ItemFormacionVacio(
        partido.id,
        equipo,
        ordenNuevo,
        Titularidad.DIRECTOR_TECNICO
      );

      // Agregar el nuevo técnico a la formación
      const formacionActualizada = [...formacion, nuevoTecnico];
      props.onFormacionActualizada(localia, formacionActualizada, true);
    }
  };

  const eliminarTecnicoHandler = async (tecnico) => {
    if (puedeEditar && formacion) {
      const tecnicos = formacion.filter(
        (item) => item.titularidad === Titularidad.DIRECTOR_TECNICO
      );

      // Si hay más de un técnico y el técnico a eliminar tiene ID (está guardado en BD)
      if (tecnicos.length > 1 && tecnico.idPartidoFormacion > 0) {
        setErrorPost('');
        setGrabando(true);
        try {
          // Llamar al DELETE del backend
          await Data.DeleteFormacion(partido.id, tecnico.idPartidoFormacion);
          // Remover el técnico del array
          const formacionActualizada = formacion.filter(
            (item) => item.idPartidoFormacion !== tecnico.idPartidoFormacion
          );
          props.onFormacionActualizada(localia, formacionActualizada, false);
        } catch (error) {
          setErrorPost(error.message);
        }
        setGrabando(false);
      } else {
        // Si es el único técnico o no tiene ID, solo limpiar los datos
        actualizarCampo(tecnico, Campos.PERSONA, null);
        if (tecnico.personaSinId) {
          actualizarCampo(tecnico, Campos.PERSONA_SIN_ID, null);
        }
      }
    }
  };

  const reordenarParticipanteHandler = (participante, direccion) => {
    if (puedeEditar && formacion) {
      const formacionActualizada = Funciones.ReordenarParticipante(
        formacion,
        participante,
        direccion
      );
      props.onFormacionActualizada(localia, formacionActualizada, true);
    }
  };

  const onClickBotonParticipante = (participante, boton) => {
    if (puedeEditar) {
      switch (boton) {
        case Boton.GOL: {
          setPopup({
            tipo: TipoPopup.GOL,
            visible: true,
            participante: participante,
            edicion: false,
          });
          break;
        }
        case Boton.ENTRA: {
          setPopup({
            tipo: TipoPopup.SUSTITUCION,
            visible: true,
            participante: participante,
            valorExtra: TipoSustitucion.ENTRA,
            edicion: participante.idSustitucionEntra,
          });
          break;
        }
        case Boton.SALE: {
          setPopup({
            tipo: TipoPopup.SUSTITUCION,
            visible: true,
            participante: participante,
            valorExtra: TipoSustitucion.SALE,
            edicion: participante.idSustitucionSale,
          });
          break;
        }
        case Boton.AMARILLA: {
          actualizarAmonestacion({
            ...participante,
            amonestado: !participante.amonestado,
          });
          break;
        }
        case Boton.ROJA: {
          setPopup({
            tipo: TipoPopup.EXPULSION,
            visible: true,
            participante: participante,
            edicion: participante.expulsado,
          });
          break;
        }
        default:
      }
    }
  };

  const onClickEditarGol = (idGol) => {
    if (puedeEditar) {
      const golEncontrado = encontrarIdNumber(goles, idGol);
      if (golEncontrado) {
        setPopup({
          tipo: TipoPopup.GOL,
          visible: true,
          participante: golEncontrado.formacionJugador,
          gol: golEncontrado,
          edicion: true,
        });
      }
    }
  };

  const ocultarPopup = () => {
    setErrorPost('');
    setPopup(PopupsFormacion.PopupOculto);
  };

  const onExpulsionAceptada = async (expulsionAceptada) => {
    setErrorPost('');
    if (puedeEditar) {
      setGrabando(true);
      try {
        if (expulsionAceptada.id > 0) {
          await Data.PutExpulsion(partido.id, expulsionAceptada);
        } else {
          const idExpulsion = await Data.PostExpulsion(partido.id, expulsionAceptada);
          expulsionAceptada = { ...expulsionAceptada, id: idExpulsion };
        }
        props.onFormacionActualizada(
          localia,
          Funciones.ActualizarExpulsionFormacion(formacion, popup.participante, expulsionAceptada),
          false
        );
        ocultarPopup();
      } catch (error) {
        setErrorPost(error.message);
      }
      setGrabando(false);
    }
  };

  const onExpulsionEliminada = async (expulsion) => {
    setErrorPost('');
    if (puedeEditar) {
      setGrabando(true);
      try {
        if (expulsion.id > 0) {
          await Data.DeleteExpulsion(partido.id, expulsion.id);
          props.onFormacionActualizada(
            localia,
            Funciones.RemoverExpulsionFormacion(formacion, popup.participante),
            false
          );
          ocultarPopup();
        }
      } catch (error) {
        setErrorPost(error.message);
      }
      setGrabando(false);
    }
  };

  const onGolAceptado = async (gol) => {
    setErrorPost('');
    if (puedeEditar) {
      setGrabando(true);
      try {
        if (gol.id > 0) {
          await Data.PutGol(partido.id, gol);
        } else {
          const idGol = await Data.PostGol(partido.id, gol);
          gol = { ...gol, id: idGol };
        }
        props.onGolGrabado(gol);
        ocultarPopup();
      } catch (error) {
        setErrorPost(error.message);
      }
      setGrabando(false);
    }
  };

  const onGolEliminado = async (gol) => {
    setErrorPost('');
    if (puedeEditar) {
      setGrabando(true);
      try {
        if (gol.id > 0) {
          await Data.DeleteGol(partido.id, gol.id);
          props.onGolEliminado(gol.id);
          ocultarPopup();
        }
      } catch (error) {
        setErrorPost(error.message);
      }
      setGrabando(false);
    }
  };

  const onSustitucionAceptada = async (sustitucion) => {
    setErrorPost('');
    if (puedeEditar) {
      setGrabando(true);
      try {
        if (sustitucion.id > 0) {
          await Data.PutSustitucion(partido.id, sustitucion);
        } else {
          const idSustitucion = await Data.PostSustitucion(partido.id, sustitucion);
          sustitucion = { ...sustitucion, id: idSustitucion };
        }
        props.onSustitucionGrabada(localia, sustitucion);
        ocultarPopup();
      } catch (error) {
        setErrorPost(error.message);
      }
      setGrabando(false);
    }
  };

  const onSustitucionEliminada = async (sustitucion) => {
    setErrorPost('');
    if (puedeEditar) {
      setGrabando(true);
      try {
        if (sustitucion.id > 0) {
          await Data.DeleteSustitucion(partido.id, sustitucion.id);
          props.onSustitucionEliminada(localia, sustitucion);
          ocultarPopup();
        }
      } catch (error) {
        setErrorPost(error.message);
      }
    }
    setGrabando(false);
    ocultarPopup();
  };

  const onTipoFormacionElegida = async (tipoFormacion) => {
    setErrorPost('');
    if (puedeEditar) {
      setGrabandoTipoFormacion(true);
      try {
        let dto = null;
        if (localia === Localia.LOCAL) {
          dto = DTOs.patchPartidoTipoFormacionLocal(tipoFormacion);
        } else if (localia === Localia.VISITANTE) {
          dto = DTOs.patchPartidoTipoFormacionVisitante(tipoFormacion);
        }
        if (dto !== null) {
          await Data.PatchPartido(partido.id, dto);
          props.onTipoFormacionActualizada(localia, tipoFormacion);
        }
      } catch (error) {
        setErrorPost(error.message);
      }
      setGrabandoTipoFormacion(false);
    }
  };

  return (
    <React.Fragment>
      {formacion && (
        <div>
          <div className={`${styles.cabeceraFormacion}`}>
            <div className={`${styles.titulo}`}>{equipo && equipo.nombre}</div>
          </div>
          <div className={`${styles.filaFormacion}`}>
            <div className={`${styles.tipoFormacion}`}>
              <div className={`${styles.tituloFormacion}`}>Formación</div>
              {puedeEditar ? (
                <React.Fragment>
                  <SelectFormacion
                    estilo={`${styles.selectFormacion}`}
                    key={localia}
                    id={localia}
                    formacionActual={tipoFormacion}
                    onFormacionElegida={onTipoFormacionElegida}
                  />
                  <MensajeGrabando isGrabando={grabandoTipoFormacion} />
                </React.Fragment>
              ) : tipoFormacion ? (
                tipoFormacion.descripcion
              ) : (
                '(desconocida)'
              )}
            </div>
            {puedeEditar && grabar && (
              <div className={`${styles.botonGrabar}`}>
                <button onClick={grabarHandler}>Grabar</button>
                <MensajeGrabando
                  estilo={`${styles.grabandoFormacion}`}
                  isGrabando={grabandoFormacion}
                />
              </div>
            )}
          </div>
          {formacion
            .filter((participante) => participante.titularidad === Titularidad.TITULAR)
            .sort((a, b) => a.orden - b.orden)
            .map((participante, index) => (
              <React.Fragment key={localia + Titularidad.TITULAR + index}>
                <div key={idEquipo + Titularidad.TITULAR + index} className={`${styles.persona}`}>
                  <ParticipanteFormacion
                    plantel={plantel}
                    formacion={formacion}
                    participante={participante}
                    cantSuplentes={cantSuplentes}
                    actualizarCampo={actualizarCampo}
                    onClick={onClickBotonParticipante}
                    onReordenar={reordenarParticipanteHandler}
                  />
                </div>
                <FormacionSeparador
                  id={localia + 's' + index}
                  visible={separadoresVisibles[index]}
                />
              </React.Fragment>
            ))}
          {cantSuplentes > 0 && (
            <React.Fragment key={localia + Titularidad.SUPLENTE}>
              <div key={localia + 'Sup'} className={`${styles.tituloSeccion}`}>
                Suplentes
              </div>
              {formacion
                .filter((participante) => participante.titularidad === Titularidad.SUPLENTE)
                .sort((a, b) => a.orden - b.orden)
                .map((participante, index) => (
                  <div
                    key={idEquipo + Titularidad.SUPLENTE + index}
                    className={`${styles.persona}`}
                  >
                    <ParticipanteFormacion
                      plantel={plantel}
                      formacion={formacion}
                      participante={participante}
                      cantSuplentes={cantSuplentes}
                      actualizarCampo={actualizarCampo}
                      onClick={onClickBotonParticipante}
                      onReordenar={reordenarParticipanteHandler}
                    />
                  </div>
                ))}
            </React.Fragment>
          )}
          <div className={`${styles.tituloSeccion}`}>
            Director Técnico&nbsp;
            {puedeEditar && (
              <BotonInsertar estilo={`${styles.botonInsertar}`} onClick={insertarTecnicoHandler} />
            )}
          </div>
          {formacion.map(
            (tecnico, index) =>
              tecnico.titularidad === Titularidad.DIRECTOR_TECNICO && (
                <div
                  key={idEquipo + Titularidad.DIRECTOR_TECNICO + index}
                  className={`${styles.persona}`}
                >
                  <TecnicoFormacion
                    key={tecnico.id + 'DT' + index}
                    id={tecnico.id + 'DT' + index}
                    plantel={plantel}
                    formacion={formacion}
                    tecnico={tecnico}
                    actualizarCampo={actualizarCampo}
                    onClick={onClickBotonParticipante}
                    onEliminar={eliminarTecnicoHandler}
                  />
                </div>
              )
          )}
          <div className={`${styles.tablaGoles}`}>
            <div className={`${styles.tituloGoles}`}>Goles</div>
            <div className={`${styles.listaGoles}`}>
              <DetalleGolesEquipo
                equipo={equipo}
                goles={goles}
                onClickEditarGol={onClickEditarGol}
              />
            </div>
          </div>
          <PopupsFormacion
            equipo={equipo}
            formacion={formacion}
            goles={goles}
            sustituciones={sustituciones}
            popup={popup}
            errores={erroresPost}
            isGrabando={grabando}
            onExpulsionAceptada={onExpulsionAceptada}
            onExpulsionEliminada={onExpulsionEliminada}
            onGolAceptado={onGolAceptado}
            onGolEliminado={onGolEliminado}
            onSustitucionAceptada={onSustitucionAceptada}
            onSustitucionEliminada={onSustitucionEliminada}
            ocultarPopup={ocultarPopup}
          />
          <MensajeCargando isCargando={isCargando} />
          <MensajeError errores={erroresGetLista} />
          <MensajeError errores={erroresPost} />
        </div>
      )}
    </React.Fragment>
  );
};

export default FormacionPartido;
